export default __webpack_public_path__ + "static/media/micimg3.7749164b.webp";